import React from "react";
import { faEnvelope } from "@fortawesome/free-regular-svg-icons";
import {
  faGithub,
  faLinkedin,
  faInstagram,
} from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { motion } from "framer-motion";

const Footer = () => {
  return (
    <footer
      id="footer"
      className="bg-black bg-opacity-60 fixed bottom-0 pt-3 pb-2 z-50 glass w-full flex flex-col items-center lg:border-none lg:shadow-none lg:w-[290px] lg:rounded-br-2xl lg:pb-4 lg:bg-transparent"
    >
      <div
        id="social"
        className="flex gap-4 text-xl text-white sm:text-neutral-500"
      >
        <motion.a
          className="fa-icon"
          target="_blank"
          rel="noreferrer"
          href="https://github.com/JohnnyTung123"
          title=""
          whileHover={{ scale: 1.15, color: "#c199e5e0" }}
          whileTap={{ scale: 1 }}
        >
          <FontAwesomeIcon icon={faGithub} />
        </motion.a>
        <motion.a
          className="fa-icon"
          target="_blank"
          rel="noreferrer"
          // href="https://www.instagram.com/johnnytungloklok/"
          title=""
          whileHover={{ scale: 1.15, color: "#c199e5e0" }}
          whileTap={{ scale: 1 }}
        >
          <FontAwesomeIcon icon={faInstagram} />
        </motion.a>
        <motion.a
          className="fa-icon"
          target="_blank"
          rel="noreferrer"
          href="https://www.linkedin.com/in/tung-yuen-lok/"
          title=""
          whileHover={{ scale: 1.15, color: "#c199e5e0" }}
          whileTap={{ scale: 1 }}
        >
          <FontAwesomeIcon icon={faLinkedin} />
        </motion.a>
        <motion.a
          className="fa-icon"
          target="_blank"
          rel="noreferrer"
          href="mailto:johnnya12399@gmail.com"
          title=""
          whileHover={{ scale: 1.15, color: "#c199e5e0" }}
          whileTap={{ scale: 1 }}
        >
          <FontAwesomeIcon icon={faEnvelope} />
        </motion.a>
      </div>
      <div className="text-[10px] text-white sm:text-neutral-500 mt-4 mb-4">
        © 2025 Johnny | All Rights Reserved.
      </div>
    </footer>
  );
};

export default Footer;
